// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"47319cff","63":"4f1cb979","119":"7d9cf3c3","126":"1bc07501","452":"b9dd4139","599":"95ce0bac","682":"e953370a","936":"bc19c4a8","983":"1390f997"}[chunkId] + ".chunk.js";
};